/* eslint-disable camelcase */
import axios from 'axios'

const CONVERT_DATA = (_d) => {
  const D = _d.data
  return D
}

const POST_REQ = async (STATE, RECOMMEND_RESULT_ID, _resolve, _path) => {
  const recommend_result_id = RECOMMEND_RESULT_ID
  const SEND_DATA:any = {
    recommend_result_id
  }
  const PARAMS = new URLSearchParams(SEND_DATA)
  const RESPONCE = await axios.post(_path, PARAMS).catch((e) => {
    _resolve(CONVERT_DATA(e.response))
  })
  RESPONCE && _resolve(CONVERT_DATA(RESPONCE))
}

export const getDashboard = (_state, _props, _resolve, _reject) => {
  const STATE = _state
  const PATH = process.env.END_DASHBOARD
  const RECOMMEND_RESULT_ID = _props.recommend_result_id
  POST_REQ(STATE,RECOMMEND_RESULT_ID, _resolve, PATH)
}
